import React from 'react';
import { Link } from 'react-router-dom';
import './header.css'

interface IHeader {
    section: string
}

function Header({section}: IHeader) {
    return (
        <div className={'flex justify-between h-14 mb-8'}>
            <Link to={'/home'}>
                <div className={'h-full flex font-dancing-script space-x-3'}>
                    <img alt={'ロゴ'} src={'favicon.png'} className={'h-14'} />
                    <h1 className={'hidden md:flex items-center'}>Ran Van de Wereld</h1>
                </div>
            </Link>

            <h1 className={'text-3xl flex items-center md:text-5xl font-raleway text-yellow-500 font-bold section'}>{decodeURI(section)}</h1>
        </div>
    );
}

export default Header;